export default "__VITE_ASSET__f752c9f2__"